<template>
  <b-container>
    <v-popover :open="popover" offset="16" placement="left">
      <!-- This will be the popover target (for the events and position) -->
      <div class="d-flex align-items-center">
        <div class="avatar p-1">
          <b-avatar class="m-2 cursor-point" v-bind:src="
            user.avatarUrl
              ? user.avatarUrl + '/' + getAuthentication()
              : ''
          " @mouseleave="triggerUnClickPopover" @mouseover="triggerClickPopover"></b-avatar>
        </div>
        <div class="media-support-info">
          <h6>{{ user.name }} {{ user.lastname }}</h6>
          <p class="mb-0 font-size-12">{{ user.phone }}</p>
        </div>
      </div>
      <!-- This will be the content of the popover -->
      <template slot="popover">
        <div class="user-details-block">
          <div class="user-profile text-center">
            <b-avatar class="img-fluid rounded avatar-100" size="6rem" v-bind:src="user.avatarUrl"></b-avatar>
          </div>
          <div class="text-center mt-3">
            <h4>
              <b>{{ user.name }} {{ user.lastname }}</b>
            </h4>
            <p>{{ user.country }}</p>
            <p>{{ user.email }}</p>
            <hr />
            <ul class="
                doctoe-sedual
                d-flex
                align-items-center
                justify-content-between
                p-0
              ">
              <li class="text-center">
                <p class="counter">{{ user.phone }}</p>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </v-popover>
  </b-container>
</template>
<script>
import IqCard from "../../components/xray/cards/iq-card";
import { xray } from "../../config/pluginInit";

export default {
  name: "UserInfo",
  components: { IqCard },
  props: {
    user: {
      default: {},
    },
  },
  mounted() {
    xray.index();
  },
  computed: {},
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    triggerUnClickPopover() {
      this.popover = false;
    },
    triggerClickPopover() {
      this.popover = true;
    },
  },
  data() {
    return {
      popover: false,
    };
  },
};
</script>
